function initExitModal() {

    if (window.innerWidth < 992) return; 

    const El = document.getElementById('exitModal')

    const myModal = new bootstrap.Modal(El)

    let exitPopupShown = false;

    if (!Cookies.get('exitPopup')) {

        El.addEventListener("hidden.bs.modal", function () {
          Cookies.set('exitPopup', true, {
            expires: 30
          });  
        });

        document.addEventListener('mouseout', function(event) {

            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            if ((event.clientY <= 0 || event.clientY >= viewportHeight) || (event.clientX <= 0 || event.clientX >= viewportWidth)) {
                if (!exitPopupShown) {
                    showExitPopup();
                    exitPopupShown = true;
                }
            }

        });

        function showExitPopup() {
            myModal.toggle()
        }

    }

    document.querySelector(".exit-modal__btn-coupon").addEventListener("click", function () {
      const coupon = this.getAttribute("data-coupon");
      navigator.clipboard.writeText(coupon).then(() => {
          alert("Cupom copiado: " + coupon);
      }).catch(err => {
          console.error("Erro ao copiar o cupom: ", err);
      });
    });

}



document.addEventListener("DOMContentLoaded", function (event) {

  if (document.querySelector(".age-verify-modal") && document.querySelector("body.modal-open")) {
    document.querySelector(".age-verify-modal").addEventListener("hidden.bs.modal", function () {
      initExitModal()
    });  
  } else {
    initExitModal()
  }  

});





